<template>
  <button type="button" @click="onClick" :class="cssClass ? cssClass + ' v-button' : 'btn btn-primary mrg-r-15 mrg-b-25 v-button'" :disabled="loading"><i v-if="loading" class='fa fa-spinner fa-spin v-button'></i><span v-if="loading">{{loadingText}}</span><span v-if="!loading">{{buttonText}}</span></button>
</template>
<script>
  export default {
    props: {
      onClick: Function,
      loading: false,
      loadingText: '',
      buttonText: '',
      cssClass: ''
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/SpinButton.vue